import script from "./ThrillRides.vue?vue&type=script&setup=true&lang=js"
export * from "./ThrillRides.vue?vue&type=script&setup=true&lang=js"

import "./ThrillRides.vue?vue&type=style&index=0&id=b099d2fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b099d2fa"]])

export default __exports__